import React, { useState, useEffect } from 'react';
import './Tabs.style.css';

const Tabs = ({
  items = [],
  activeKey,
  position = 'left',
  style = {},
  layoutStyle = {},
  textStyle = {},
  onChange = () => {},
  type = 'default',
  fullscreen = true,
  activeColor,
  bordered = true,
  activeTextStyle = {},
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const [tabPosition, setTabPosition] = useState('flex-start');
  const [selectedKey, setSelectedKey] = useState(activeKey ?? items[0].key);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  const handleTabKey = ({ key }) => {
    if (onChange) {
      onChange(key);
    } else {
      setSelectedKey(key);
    }
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  useEffect(() => {
    const type = position.toLocaleUpperCase();

    let p = '';
    switch (type) {
      case 'LEFT':
        p = 'flex-start';
        break;
      case 'RIGHT':
        p = 'flex-end';
        break;
      case 'CENTER':
        p = 'center';
        break;
      default:
        p = 'flex-start';
        break;
    }

    setTabPosition(p);
  }, [position]);

  useEffect(() => {
    if (activeKey) {
      setSelectedKey(activeKey);
    }
  }, [activeKey]);

  /* ===== Render ===== */
  return type.toLocaleUpperCase() !== 'CARD ' ? (
    <div
      className="tabs_layout"
      style={{ justifyContent: tabPosition, ...layoutStyle }}
    >
      {items.map((_item, _index) => (
        <div
          key={`${_item.key}`}
          className={`tabs_item ${_item.key === selectedKey ? 'active' : ''}`}
          onClick={() => handleTabKey(_item)}
          style={{ ...style }}
        >
          <p
            style={{
              ...textStyle,
              ...(activeColor && {
                color: _item.key === selectedKey && activeColor,
              }),
              ...(selectedKey === _item.key && activeTextStyle),
            }}
          >
            {_item.icon && (
              <span style={{ paddingRight: 10 }}>{_item.icon}</span>
            )}
            {_item.label}
            {bordered ? (
              <span
                className="bordered"
                style={{
                  background:
                    _item.key === selectedKey ? activeColor : 'transparent',
                }}
              ></span>
            ) : null}
          </p>
        </div>
      ))}
    </div>
  ) : (
    <div className="tabs_card_layout" style={{ ...layoutStyle }}>
      {items.map((_item) => (
        <div
          key={`${_item.key}`}
          className={`tabs_card_item ${
            _item.key === selectedKey ? 'active' : ''
          }`}
          onClick={() => handleTabKey(_item)}
          style={{
            width: fullscreen ? `calc(100% / ${items.length})` : 'auto',
            ...style,
          }}
        >
          <p>
            {_item.icon && (
              <span style={{ paddingRight: 10 }}>{_item.icon}</span>
            )}
            {_item.label}
          </p>
        </div>
      ))}
      {!fullscreen && (
        <div className="tabs_card_item empty" style={{ flex: 1 }}></div>
      )}
    </div>
  );
};

export default Tabs;
